module.exports = __webpack_public_path__ + "static/oop_poly-fee2d426bb2f91882e1274a10cf51cb9.png";